/**
 * OAuth2 / OIDC error codes that indicate the refresh token itself is no longer usable
 * (user session ended, consent revoked, client disabled, etc.). For these we must log the
 * user out. Anything else (network failure, timeout, 5xx from the SSO endpoint) is treated
 * as a transient issue: the existing access token stays in place and the next request may
 * retry the refresh.
 */
const OIDC_AUTH_ERROR_CODES = [
  'invalid_grant',
  'login_required',
  'interaction_required',
  'invalid_client',
  'unauthorized_client',
  'access_denied',
] as const;

export function isOidcAuthError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const code = (err as { error?: unknown }).error;
  return typeof code === 'string' && (OIDC_AUTH_ERROR_CODES as readonly string[]).includes(code);
}
